import { ApiRequest } from "src/models/api.request";
import VwVezneMakbuzIzlemeDTO from "src/models/Vezne/MakbuzIzleme/VwVezneMakbuzIzlemeDTO";
import { ApiService } from "src/services/core";

class VwVezneMakbuzIzlemeDTOService {
    private service: ApiService<VwVezneMakbuzIzlemeDTO>;
    constructor() {
        this.service = new ApiService<VwVezneMakbuzIzlemeDTO>("VwVezneMakbuzIzlemeDTO");
    };
    // getAllDataMakbuzIzleme = (v: { basTarih: string, bitTarih: string, yetkiliVezne: string }) => {
    //     let req: ApiRequest<VwVezneMakbuzIzlemeDTO> = {
    //         filters: {
    //             groupOperator: 'and',
    //             predicates: [
    //                 {
    //                     fieldName: 'tarih',
    //                     operator: '>=',
    //                     value1: v.basTarih
    //                 },
    //                 {
    //                     fieldName: 'tarih',
    //                     operator: '<',
    //                     value1: v.bitTarih
    //                 },
    //             ]
    //         }
    //     }
    //     let vezneArr = v.yetkiliVezne?.split(",");
    //     if (vezneArr?.length > 0) {
    //         req.filters.predicates.push({
    //             fieldName: 'vezneId',
    //             operator: 'in',
    //             not: false,
    //             value1: vezneArr
    //         }
    //         )
    //     }
    //     return this.service.find(req);
    // };
    getByPosId = (id: number) => {
        return this.service.getOne(id);
    };
    getDetayliArama = (aramaModel: VwVezneMakbuzIzlemeDTO) => {
        let req: ApiRequest<VwVezneMakbuzIzlemeDTO> = {
            sorts: [
                { fieldName: "id", ascending: false },
            ]
        }
        req.filters = {
            groupOperator: 'and',
            predicates: []
        }
        if (aramaModel.odemeTipId?.length > 0) {
            let odemeTipArr = aramaModel.odemeTipId.split(",");
            req.filters.predicates.push({
                fieldName: "odemeTipId",
                operator: "in",
                not: false,
                value1: odemeTipArr
            })
        }
        if (aramaModel.vezneId?.length > 0) {
            let vezneArr = aramaModel.vezneId.split(",");
            req.filters.predicates.push({
                fieldName: "vezneId",
                operator: "in",
                not: false,
                value1: vezneArr
            })
        }
        if (aramaModel.tarih)
            req.filters.predicates.push(
                {
                    fieldName: 'tarih',
                    operator: '>=',
                    value1: aramaModel.tarih
                },
                {
                    fieldName: 'tarih',
                    operator: '<',
                    value1: aramaModel.tarih2
                }
            )
        if (req.filters.predicates.length === 0)
            return;
        return this.service.find(req)
    };
};

export default new VwVezneMakbuzIzlemeDTOService();